import getWithToken from './base/get-with-token'

const customerHasSumsData = (customerIds) => getWithToken(`/customer-has-sums-data`)({
  customer_ids: customerIds
})

export default customerHasSumsData
